import { Route } from 'react-router-dom'
import About from './pages/About'
import Contact from './pages/Contact'
import Editor from './pages/Editor'
import Home from './pages/Home'
import Gallery from './pages/Gallery'
import Login from './pages/Login'
import Subscription from './pages/credit/Subscription'
import SubscriptionVerify from './pages/credit/SubscriptionVerify'
import NotFound from './pages/NotFound'
import Work from './pages/Work'
import TopUpVerify from './pages/credit/TopUpVerify'
import TopUp from './pages/credit/Top_up'
import ComingSoon from './pages/ComingSoon'
import Profile from './pages/Profile'
import Credit from './pages/credit/Credit'
import Tripo3d from './pages/Tripo3d'
import AssetsBrowser from './pages/AssetsBrowser'

export let AppRoutes = (
  <>
    <Route path="/" element={<Home />} />
    {/* <Route path="gallery" element={<Gallery />} /> */}
    <Route path="editor" element={<Editor />} />
    <Route path="editor/:scene_id" element={<Editor />} />
    <Route path="tripo3d" element={<Tripo3d />} />
    <Route path="tripo3d/:object_id" element={<Tripo3d />} />
    <Route path="assets" element={<AssetsBrowser />} />
    <Route path="login" element={<Login />} />
    <Route path="profile" element={<Profile />} />
    <Route path="credit" element={<Credit />} />
    <Route path="top-up" element={<TopUp />} />
    <Route path="subscription" element={<Subscription />} />
    <Route path="*" element={<NotFound />} />,
    <Route path="/work" element={<Work />} />
    <Route path="/about" element={<About />} />
    <Route path="/contact" element={<Contact />} />
    <Route path="/top-up/verify" element={<TopUpVerify />} />
    <Route path="/subscription/verify" element={<SubscriptionVerify />} />
    <Route path="*" element={<NotFound />} />
  </>
)
